import { render, staticRenderFns } from "./gatherSet.vue?vue&type=template&id=c3d28034&scoped=true&"
import script from "./gatherSet.vue?vue&type=script&lang=js&"
export * from "./gatherSet.vue?vue&type=script&lang=js&"
import style0 from "./gatherSet.vue?vue&type=style&index=0&id=c3d28034&prod&lang=scss&scoped=true&"
import style1 from "./gatherSet.vue?vue&type=style&index=1&id=c3d28034&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d28034",
  null
  
)

export default component.exports